import { Market } from '../../graphql/API';
import { OptionEntry } from '../../utils/generate-options';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminListMarketsAsOptionsApi = async (): Promise<OptionEntry[]> => {
  const result = await executeGql<Market[]>(adminListMarketsForOptionsQuery, {});
  const items = processGqlResult<Market[]>('adminListMarkets.items', result);

  return items.map<OptionEntry>((m: Market) => {
    return {
      key: m.id || '',
      value: `${m.name} (${m.totalUsers})`,
    };
  });
};

const adminListMarketsForOptionsQuery = /* GraphQL */ `
  query AdminListMarkets {
    adminListMarkets(
      filter: {
        status: active
        sortBy: "totalUsers"
        sortDirection: "desc"
        limit: 10000
        offset: 0
      }
    ) {
      items {
        countryCode
        id
        name
        stateProvince
        totalUsers
      }
    }
  }
`;
